module.exports = __webpack_public_path__ + "img/btn-phone.27006a6a.png";